import { render, staticRenderFns } from "./ListDomains.vue?vue&type=template&id=1dceb86f&scoped=true"
import script from "./ListDomains.vue?vue&type=script&lang=js"
export * from "./ListDomains.vue?vue&type=script&lang=js"
import style0 from "./ListDomains.vue?vue&type=style&index=0&id=1dceb86f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dceb86f",
  null
  
)

export default component.exports